import { isIos } from './isIos'

export function getApplicationLink() {
  const isIOS = isIos()

  return isIOS
    ? 'https://apps.apple.com/ru/app/kazanexpress/id1438104323'
    : 'https://play.google.com/store/apps/details?id=com.kazanexpress.ke_app'
}
